<template>
    <b-container fluid class="w-100 h-100 m-0 p-0 d-flex flex-column" :style="generateVariantStyle(Variant)">
        <b-row class="w-100 h-100 m-0 overflow-auto" v-if="activeTab == 0">
            <!-- Liste des activités -->
            <b-col class="m-0 p-1 border border-left-0 border-bottom-0 border-top-0 border-light">
                <b-card class="h-100 border-0"
                        header-tag="header" header-bg-variant="light" header-class="bg-white pb-0" variant="white"
                        no-body>
                    <template #header>
                        <b-row class="headerHeight"
                               :style="activityHeaderHeight != '' ? 'height: ' + activityHeaderHeight : '' ">
                            <b-col>
                                <h5>Activités</h5>
                            </b-col>
                            <b-col cols="auto">
                                <b-button @click.stop="modalSelectedActivity = {}" class="my-1 btn-circle"
                                          v-b-tooltip.hover title="Ajouter une activité"
                                          :variant="Variant" v-b-modal.modal-modif-activity>
                                    <b-icon icon="plus"/>
                                </b-button>
                            </b-col>
                        </b-row>
                    </template>
                    <b-row class="m-0 p-0 h-100 d-flex flex-column">
                        <b-col class="m-0 p-0 h-100 overflow-auto">
                            <GenericTable :Variant="Variant" :Headers="activityFields" :Rows="activities"
                                          :EnableSelection="true" :EnablePagination="true"
                                          :SelectionType="selectionTypeEnum.Simple" :Loading="loadingActivities"
                                          :PerPage="activityItemPerPage" :CurrentPage.sync="activityCurrentPage"
                                          :ShowDeleteButton="false" :ShowModifyButton="false"
                                          @ClickOnRowsEvent="loadSubctivities">
                                <template #menu-right="row">
                                    <GenericButton @click.stop.prevent="modifyActivity(row.row)"
                                                   :Type="ButtonsType.Icon" :ButtonAction="ButtonsAction.Edit"
                                                   v-if="row.row.Status != 2"/>
                                </template>
                                <template #menu-left="row">
                                    <b-row class="m-0 w-100">
                                        <b-col
                                            class="d-flex flex-nowrap align-content-end justify-content-center p-0 m-0 w-100">
                                            <GenericButton @click.stop.prevent="removeActivity(row.row)"
                                                           VariantOverride="danger"
                                                           :Type="ButtonsType.Icon" :ButtonAction="ButtonsAction.Delete"
                                                           v-if="row.row.Status == 0"/>
                                            <GenericButton @click.stop.prevent="publishActivity(row.row)"
                                                           VariantOverride="success" Tooltip="Publier"
                                                           :Type="ButtonsType.Icon"
                                                           :ButtonAction="ButtonsAction.Publish"
                                                           v-if="row.row.Status == 0"/>
                                            <GenericButton @click.stop.prevent="removeActivity(row.row, true)"
                                                           VariantOverride="danger"
                                                           :Type="ButtonsType.Icon"
                                                           :ButtonAction="ButtonsAction.Archive"
                                                           v-if="row.row.Status == 1"/>
                                        </b-col>
                                    </b-row>
                                </template>
                                <template #column(Status)="row">
                                    <div class="w-100 text-center">
                                        <b-icon v-if="row.row != undefined && row.row !== null" icon="circle-fill"
                                                v-b-tooltip.noninteractive.hover.top
                                                :title="row.row.Status == '0' ? 'A publier' : (row.row.Status == '1' ? 'Publier' : 'Archiver')"
                                                :variant="row.row.Status == '0' ? 'warning' : (row.row.Status == '1' ? 'success' : 'danger')"/>
                                    </div>
                                </template>
                            </GenericTable>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <!-- Liste des sous-activités en correspondance avec l'activité sélectionnée -->
            <b-col class="m-0 p-1">
                <b-card class="h-100 border-0 bg-white"
                        header-tag="header" header-bg-variant="light" header-class="bg-white pb-0"
                        no-body>
                    <template #header>
                        <b-row class="headerHeight">
                            <b-col>
                                <h5 class="mb-0">Sous-activités</h5>
                                <h6 v-if="activities.find(a=> a.Selected)">pour l'activité :
                                    {{ activities.find(a => a.Selected == true)?.Name }}</h6>
                            </b-col>
                            <b-col cols="auto"
                                   v-if="activities.find(a=> a.Selected) && (activities.find(a=> a.Selected == true)?.Status ?? -1) != 2 ">
                                <b-button @click.stop="modalSelectedSubactivity = {}" class="my-1 btn-circle"
                                          v-b-tooltip.hover title="Ajouter une sous-activité"
                                          :variant="Variant" v-b-modal.modal-modif-subactivity>
                                    <b-icon icon="plus"/>
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row
                            v-if="!(activities.find(a=> a.Selected))">
                            <b-col>
                                Veuillez cliquer sur la ligne d'activité.
                            </b-col>
                        </b-row>
                    </template>
                    <b-row class="m-0 p-0 h-100 d-flex flex-column" v-if="activities.find(a=> a.Selected)">
                        <b-col class="m-0 p-0 h-100 overflow-auto">
                            <GenericTable :Variant="Variant" :Headers="subactivityFields" :Rows="subactivities"
                                          :EnableSelection="true" :EnablePagination="true"
                                          :SelectionType="selectionTypeEnum.Simple" :Loading="loadingSubactivities"
                                          :PerPage="subactivityItemPerPage" :CurrentPage.sync="subactivityCurrentPage"
                                          :ShowDeleteButton="false" :ShowModifyButton="false"
                                          @ClickOnRowsEvent="loadConstantes">
                                <template #menu-right="row">
                                    <GenericButton @click.stop.prevent="modifySubactivity(row.row)"
                                                   :Type="ButtonsType.Icon" :ButtonAction="ButtonsAction.Edit"
                                                   v-if="row.row.Status != 2 && (activities.find(a=> a.Selected == true)?.Status ?? -1) != 2"/>
                                </template>
                                <template #menu-left="row">
                                    <b-row class="m-0 w-100">
                                        <b-col
                                            class="d-flex flex-nowrap align-content-end justify-content-center p-0 m-0 w-100">
                                            <GenericButton @click.prevent.stop="removeSubactivity(row.row)"
                                                           VariantOverride="danger"
                                                           :Type="ButtonsType.Icon" :ButtonAction="ButtonsAction.Delete"
                                                           v-if="row.row.Status == 0 && (activities.find(a=> a.Selected == true)?.Status ?? -1) != 2"/>
                                            <GenericButton @click.stop.prevent="publishSubactivity(row.row)"
                                                           VariantOverride="success" Tooltip="Publier"
                                                           :Type="ButtonsType.Icon"
                                                           :ButtonAction="ButtonsAction.Publish"
                                                           v-if="row.row.Status == 0 && (activities.find(a=> a.Selected == true)?.Status ?? -1) != 2"/>
                                            <GenericButton @click.stop.prevent="removeSubactivity(row.row, true)"
                                                           VariantOverride="danger"
                                                           :Type="ButtonsType.Icon"
                                                           :ButtonAction="ButtonsAction.Archive"
                                                           v-if="row.row.Status == 1 && (activities.find(a=> a.Selected == true)?.Status ?? -1) != 2"/>
                                        </b-col>
                                    </b-row>
                                </template>
                                <template #column(Status)="row">
                                    <div class="w-100 text-center">
                                        <b-icon v-if="row.row != undefined && row.row !== null" icon="circle-fill"
                                                v-b-tooltip.noninteractive.hover.top
                                                :title="row.row.Status == '0' ? 'A publier' : (row.row.Status == '1' ? 'Publier' : 'Archiver')"
                                                :variant="row.row.Status == '0' ? 'warning' : (row.row.Status == '1' ? 'success' : 'danger')"/>
                                    </div>
                                </template>
                            </GenericTable>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="w-100 h-100 m-0 overflow-auto" v-if="activeTab == 1">
            <b-col class="m-0 p-1 h-100 w-100 d-flex flex-column">
                <b-row class="m-0 p-0" md="auto">
                    <b-col class="m-0 p-1 h-100 align-content-center">
                        <h4>
                            <b-row class="m-0 p-0 w-100">
                                Activité "{{ activities.find(a => a.Selected == true)?.Name }}"
                            </b-row>
                            <b-row class="m-0 p-0 w-100">
                                Sous-activité "{{ modalSelectedSubactivity.Name }}"
                            </b-row>
                        </h4>
                    </b-col>
                    <b-col cols="auto" class="m-0 p-0 align-content-center">
                        <GenericButton @click.stop.prevent="backConstantes" VariantOverride="outline-dark"
                                       :Tooltip="$t('Close')"
                                       :Type="ButtonsType.Label" :ButtonAction="ButtonsAction.Close"/>
                    </b-col>
                    <b-col cols="auto" class="m-0 p-0 align-content-center">
                        <GenericButton @click.stop.prevent="reloadComposantes" VariantOverride="dark"
                                       :Type="ButtonsType.Icon" :ButtonAction="ButtonsAction.Erase"
                                       Tooltip="Restaurer les données enregistrées sans modification"/>
                    </b-col>
                    <b-col cols="auto" class="m-0 p-0 align-content-center">
                        <GenericButton @click.stop.prevent="saveComposantes" Tooltip="Enregistrer les composantes"
                                       :Modify="modifComposante" :Outline="false" :VariantOverrideSave="Variant"
                                       VariantOverride="dark"
                                       :Type="ButtonsType.Icon" :ButtonAction="ButtonsAction.Save"/>
                    </b-col>
                </b-row>
                <div class="overflow-auto">
                    <!-- Indicateurs d'intensité d'usage -->
                    <b-card class="mb-2" header-tag="header" no-body>
                        <template #header>
                            <b-row @click.stop="activeComposanteIndicator = !activeComposanteIndicator">
                                <b-col>
                                    <h5 class="mb-0">Indicateurs d'intensité d'usage</h5>
                                    <template v-if="activeComposanteIndicator">
                                        Dans le cas où un indicateur ne doit pas être transmis à OPERAT, celui-ci doit
                                        contenir la suite de lettres
                                        <span class="text-danger"><u><b>"SCAP"</b></u></span>
                                    </template>
                                </b-col>
                                <b-col cols="auto">
                                    <b-button v-if="activeComposanteIndicator" size="sm"
                                              class="bg-transparent border-0 text-black"
                                              @click.stop="activeComposanteIndicator = !activeComposanteIndicator">
                                        <!-- Close -> "Fermer" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5"
                                                role="button"/>
                                    </b-button>

                                    <b-button v-else size="sm" class="bg-transparent border-0 text-black"
                                              @click.stop="activeComposanteIndicator = !activeComposanteIndicator">
                                        <!-- Open -> "Ouvrir" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down" scale="1.5"
                                                role="button"/>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>
                        <b-card-body v-if="activeComposanteIndicator">
                            <b-row class="m-0 p-0">
                                <b-col
                                    class="m-0 p-2 border border-5 border-light border-left-0 border-bottom-0 border-top-0">
                                    <b-row class="pb-2">
                                        <b-col>
                                            <h6 class="mb-0">Indicateur d’intensité d’usage à renseigner par
                                                l’assujetti</h6>
                                            Valeur de référence associée à la USE étalon
                                        </b-col>
                                        <b-col cols="auto">
                                            <b-button
                                                @click.stop="modalSelectedIntensity = { userModified: true, allowNegative: true, status: 0 }"
                                                v-b-tooltip.hover title="Ajouter un indicateur d’intensité d’usage"
                                                :variant="Variant"
                                                class="m-0 my-1 btn-circle" v-b-modal.modal-modif-intensity>
                                                <b-icon icon="plus"/>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <b-table-simple hover small caption-top responsive class="text-left">
                                        <b-tbody>
                                            <b-tr
                                                v-for="(intensity, indexI) in composantes?.indicators.filter(a=> a.userModified)"
                                                :key="indexI">
                                                <b-td class="w-auto align-content-center justify-content-center">
                                                    <b-row class="m-0 w-100">
                                                        <b-col
                                                            class="d-flex flex-nowrap align-content-end justify-content-center p-0 m-0 w-100">
                                                            <GenericButton :ButtonAction="ButtonsAction.Delete"
                                                                           :Type="ButtonsType.Icon"
                                                                           @click.stop.prevent="removeIntensity(intensity)"
                                                                           VariantOverride="danger"
                                                                           :hidden="intensity.status != 0"/>
                                                            <GenericButton :ButtonAction="ButtonsAction.Publish"
                                                                           :Type="ButtonsType.Icon"
                                                                           @click.stop.prevent="publishIntensity(intensity)"
                                                                           VariantOverride="success"
                                                                           Tooltip="Publier"
                                                                           :hidden="intensity.status != 0"/>
                                                            <GenericButton :ButtonAction="ButtonsAction.Archive"
                                                                           :Type="ButtonsType.Icon"
                                                                           @click.stop.prevent="removeIntensity(intensity, true)"
                                                                           VariantOverride="danger"
                                                                           :hidden="intensity.status != 1"/>
                                                        </b-col>
                                                    </b-row>
                                                </b-td>
                                                <b-td class="w-auto position-relative align-content-center"
                                                      :class="intensity.status == 2 ? 'text-decoration-line-through': ''">
                                                    {{ intensity.code }}
                                                </b-td>
                                                <b-td class="w-auto position-relative align-content-center"
                                                      :class="intensity.status == 2 ? 'text-decoration-line-through': ''">
                                                    {{ intensity.labelFr }}
                                                </b-td>
                                                <b-td class="w-auto position-relative align-content-center text-right"
                                                      :class="intensity.status == 2 ? 'text-decoration-line-through': ''">
                                                    {{ intensity.value }}
                                                </b-td>
                                                <b-td class="align-content-center justify-content-center">
                                                    <div class="w-100 text-center">
                                                        <b-icon v-if="intensity != undefined && intensity !== null"
                                                                icon="circle-fill" v-b-tooltip.noninteractive.hover.top
                                                                :title="intensity.status == '0' ? 'A publier' : (intensity.status == '1' ? 'Publier' : 'Archiver')"
                                                                :variant="intensity.status == '0' ? 'warning' : (intensity.status == '1' ? 'success' : 'danger')"/>
                                                    </div>
                                                </b-td>
                                                <b-td class="w-auto align-content-center justify-content-center">
                                                    <GenericButton @click.stop.prevent="modifyIntensity(intensity)"
                                                                   :Type="ButtonsType.Icon"
                                                                   :ButtonAction="ButtonsAction.Edit"
                                                                   v-if="intensity.status != 2"/>
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                                <b-col class="m-0 ml-3 p-2">
                                    <b-row class="pb-2">
                                        <b-col><h6>Indicateur d’intensité d’usage étalon</h6></b-col>
                                        <b-col cols="auto">
                                            <b-button
                                                @click.stop="modalSelectedIntensity = { userModified: false, allowNegative: true, status: 0 }"
                                                v-b-tooltip.hover
                                                title="Ajouter un indicateur d’intensité d’usage étalon"
                                                :variant="Variant"
                                                class="m-0 my-1 btn-circle" v-b-modal.modal-modif-intensity>
                                                <b-icon icon="plus"/>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <b-table-simple hover small caption-top responsive class="text-left">
                                        <b-tbody>
                                            <b-tr
                                                v-for="(intensity, indexI) in composantes?.indicators.filter(a=> !a.userModified)"
                                                :key="indexI">
                                                <b-td class="w-auto align-content-center justify-content-center">
                                                    <b-row class="m-0 w-100">
                                                        <b-col
                                                            class="d-flex flex-nowrap align-content-end justify-content-center p-0 m-0 w-100">
                                                            <GenericButton :ButtonAction="ButtonsAction.Delete"
                                                                           :Type="ButtonsType.Icon"
                                                                           @click.stop.prevent="removeIntensity(intensity)"
                                                                           VariantOverride="danger"
                                                                           :hidden="intensity.status != 0"/>
                                                            <GenericButton :ButtonAction="ButtonsAction.Publish"
                                                                           :Type="ButtonsType.Icon"
                                                                           @click.stop.prevent="publishIntensity(intensity)"
                                                                           VariantOverride="success"
                                                                           Tooltip="Publier"
                                                                           :hidden="intensity.status != 0"/>
                                                            <GenericButton :ButtonAction="ButtonsAction.Archive"
                                                                           :Type="ButtonsType.Icon"
                                                                           @click.stop.prevent="removeIntensity(intensity, true)"
                                                                           VariantOverride="danger"
                                                                           :hidden="intensity.status != 1"/>
                                                        </b-col>
                                                    </b-row>
                                                </b-td>
                                                <b-td class="w-auto position-relative align-content-center"
                                                      :class="intensity.status == 2 ? 'text-decoration-line-through': ''">
                                                    {{ intensity.code }}
                                                </b-td>
                                                <b-td class="w-auto position-relative align-content-center"
                                                      :class="intensity.status == 2 ? 'text-decoration-line-through': ''">
                                                    {{ intensity.labelFr }}
                                                </b-td>
                                                <b-td class="w-auto position-relative align-content-center text-right"
                                                      :class="intensity.status == 2 ? 'text-decoration-line-through': ''">
                                                    {{ intensity.value }}
                                                </b-td>
                                                <b-td class="align-content-center justify-content-center">
                                                    <div class="w-100 text-center">
                                                        <b-icon v-if="intensity != undefined && intensity !== null"
                                                                icon="circle-fill" v-b-tooltip.noninteractive.hover.top
                                                                :title="intensity.status == '0' ? 'A publier' : (intensity.status == '1' ? 'Publier' : 'Archiver')"
                                                                :variant="intensity.status == '0' ? 'warning' : (intensity.status == '1' ? 'success' : 'danger')"/>
                                                    </div>
                                                </b-td>
                                                <b-td class="w-auto align-content-center justify-content-center">
                                                    <GenericButton @click.stop.prevent="modifyIntensity(intensity)"
                                                                   :Type="ButtonsType.Icon"
                                                                   :ButtonAction="ButtonsAction.Edit"
                                                                   v-if="intensity.status != 2"/>
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                    <!-- Composantes USE -->
                    <b-card class="mb-2" header-tag="header" no-body>
                        <template #header>
                            <b-row @click.stop="activeComposanteUSE = !activeComposanteUSE">
                                <b-col><h5 class="mb-0">Composantes USE</h5></b-col>
                                <b-col cols="auto">
                                    <b-button v-if="activeComposanteUSE" size="sm"
                                              class="bg-transparent border-0 text-black"
                                              @click.stop="activeComposanteUSE = !activeComposanteUSE">
                                        <!-- Close -> "Fermer" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5"
                                                role="button"/>
                                    </b-button>

                                    <b-button v-else size="sm" class="bg-transparent border-0 text-black"
                                              @click.stop="activeComposanteUSE = !activeComposanteUSE">
                                        <!-- Open -> "Ouvrir" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down" scale="1.5"
                                                role="button"/>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>
                        <b-card-body v-if="activeComposanteUSE">
                            <b-row class="m-1 h-100">
                                <b-col cols="1" align-v="center" class="font-weight-bold m-auto p-0">
                                    <label for="USEEtalon">USE étalon (KWh/m²/an)</label>
                                </b-col>
                                <b-col>
                                    <b-form-input id="USEEtalon" type="number" @input.passive="modifComposante = true"
                                                  v-model="composantes.useValue"></b-form-input>
                                </b-col>
                                <b-col cols="auto"></b-col>
                                <b-col cols="1" align-v="center" class="font-weight-bold m-auto p-0">
                                    <label for="PartUSEVariable">Part_USE_variable</label>
                                </b-col>
                                <b-col>
                                    <b-form-input id="PartUSEVariable" type="number" @input="modifComposante = true"
                                                  v-model="composantes.useVariable"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="m-1 h-100">
                                <b-col cols="2" align-v="center" class="font-weight-bold m-auto p-0">
                                    <label for="USEEtalon">
                                        Formule de modulation<br/>(USE modulé (kWh/m²/an)
                                        <b-badge class="align-self-center ml-2" :variant="Variant" v-b-tooltip.hover
                                                 title="Les intensités d'usage doivent être indiquées entre croché '[]'.">
                                            <b-icon icon="info"/>
                                        </b-badge>
                                        <br/>
                                        <small><u>Mots clé :</u> [USEEtalon] / [Part_USE_variable] / [Hauteur] /
                                            [Surface] / [CVC]...</small>
                                    </label>
                                </b-col>
                                <b-col cols="auto" align-v="center" class="font-weight-bold m-auto p-0"> =</b-col>
                                <b-col class="pr-0">
                                    <b-form-textarea id="textarea-small" @input.passive="modifComposante = true"
                                                     class="h-100"
                                                     v-model="composantes.formula">
                                    </b-form-textarea>
                                </b-col>
                                <b-col md="auto" class="pl-0">
                                    <b-button :variant="'outline-' + Variant" class="h-100 border-0"
                                              @click.prevent.stop="checkComposantesFormula"
                                              v-b-tooltip.hover title="Vérifier">
                                        <b-icon icon="check-lg"/>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                    <!-- Composantes en fonction des zones climatiques -->
                    <b-card class="mb-2" header-tag="header" no-body>
                        <template #header>
                            <b-row @click.stop="activeComposante = !activeComposante">
                                <b-col><h5 class="mb-0">Composantes en fonction des zones climatiques</h5></b-col>
                                <b-col cols="auto">
                                    <b-button class="border-0" @click.stop="textAreaClimaticalZone = ''"
                                              v-b-tooltip.hover
                                              title="Ajouter des composantes en fonction des zones climatiques à partir de l'arrêté"
                                              v-b-modal.modal-import-climaticalzone
                                              :variant="'outline-' + Variant">
                                        <b-icon icon="question-circle"/>
                                    </b-button>
                                    <b-button v-if="activeComposante" size="sm"
                                              class="bg-transparent border-0 text-black"
                                              @click.stop="activeComposante = !activeComposante">
                                        <!-- Close -> "Fermer" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5"
                                                role="button"/>
                                    </b-button>

                                    <b-button v-else size="sm" class="bg-transparent border-0 text-black"
                                              @click.stop="activeComposante = !activeComposante">
                                        <!-- Open -> "Ouvrir" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down" scale="1.5"
                                                role="button"/>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>
                        <b-card-body v-if="activeComposante">
                            <b-row class="h-100 m-0 p-0">
                                <b-col class="h-100 m-0 p-1">
                                    <b-form-group v-slot="{ ariaDescribedby }" class="font-weight-bold h-100 mb-0">
                                        <b-form-radio-group name="some-radios" v-model="composantes.type" plain
                                                            variant="private" :aria-describedby="ariaDescribedby">
                                            <b-form-radio value="None">
                                                Aucune
                                            </b-form-radio>
                                            <b-form-radio value="CVC">
                                                Composante CVC (en kWh/m²/an)
                                            </b-form-radio>
                                            <b-form-radio value="USE">
                                                Composante USE (en kWh/m²/an)
                                            </b-form-radio>
                                            <b-form-radio value="PUE_Zone">
                                                PUE_Zone (Power Usage Effectiveness)
                                            </b-form-radio>
                                        </b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="composantes?.type != 'None'" class="w-100 m-0">
                                <b-col class="h-100 m-0 p-1 w-100">
                                    <b-table-simple hover small caption-top responsive class="text-center w-100">
                                        <b-thead head-variant="gray">
                                            <b-tr>
                                                <b-th rowspan="2" size="sm">
                                                    <template v-if="composantes?.typeActives == 'CVC'">
                                                        Composante CVC<br/>(en kWh/m²/an)
                                                    </template>
                                                    <template v-if="composantes?.typeActives == 'USE'">
                                                        Composante USE<br/>(en kWh/m²/an)
                                                    </template>
                                                    <template v-if="composantes?.typeActives == 'PUE_Zone'">
                                                        PUE_Zone<br/>(Power Usage Effectiveness)
                                                    </template>
                                                </b-th>
                                                <b-th :colspan="composantesBDD.climaticAreas.length">Zones climatiques
                                                </b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th v-for="(climaticArea, index) in composantesBDD.climaticAreas"
                                                      :key="index">
                                                    {{ climaticArea.labelFr }}
                                                </b-th>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody>
                                            <b-tr v-for="(altitude, indexA) in composantesBDD.altitudes" :key="indexA">
                                                <b-th>
                                                    <template v-for="(label, indexL) in altitude.labelFr.split('/')">
                                                        {{ label }} <br
                                                        v-if="indexL != altitude.labelFr.split('/').length - 1"/>
                                                    </template>
                                                </b-th>
                                                <b-td v-for="(climaticArea, indexC) in composantesBDD.climaticAreas"
                                                      :key="indexC"
                                                      :class="composantesBDD.impossibleMix.findIndex(a=> a.altitudeId == altitude.id && a.climaticAreaId == climaticArea.id) == -1 ?
                                                            '' : 'bg-gray-light'">
                                                    <b-form-input number no-wheel
                                                                  :ref="'climaticalZone_' + altitude.id + '_' + climaticArea.id"
                                                                  :formatter="numberFormatter"
                                                                  @input.passive="modifComposante = true"
                                                                  v-if="composantesBDD.impossibleMix.findIndex(a=> a.altitudeId == altitude.id && a.climaticAreaId == climaticArea.id) == -1"
                                                                  v-model="composantes.composanteValues[altitude.id][climaticArea.id].value"
                                                    />
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                    <!-- Valeurs de Chauffage<sub>abs</sub> / Refroidissement<sub>abs</sub> / Ventilation<sub>abs</sub> en fonction des zones climatiques -->
                    <b-card class="mb-2" header-tag="header" no-body>
                        <template #header>
                            <b-row @click.stop="activeValues = !activeValues">
                                <b-col><h5 class="mb-0">Valeurs de Chauffage<sub>abs</sub> /
                                    Refroidissement<sub>abs</sub> /
                                    Ventilation<sub>abs</sub>
                                    en fonction des zones climatiques</h5>
                                </b-col>
                                <b-col cols="auto">
                                    <b-button v-if="activeValues" size="sm" class="bg-transparent border-0 text-black"
                                              @click.stop="activeValues = !activeValues">
                                        <!-- Close -> "Fermer" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5"
                                                role="button"/>
                                    </b-button>

                                    <b-button v-else size="sm" class="bg-transparent border-0 text-black"
                                              @click.stop="activeValues = !activeValues">
                                        <!-- Open -> "Ouvrir" -->
                                        <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down" scale="1.5"
                                                role="button"/>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>
                        <b-card-body v-if="activeValues">
                            <b-row class="h-100 m-0 p-0">
                                <b-col class="h-100 m-0 p-1">
                                    <b-form-group v-slot="{ ariaDescribedby }" class="font-weight-bold h-100 mb-0">
                                        <b-form-checkbox-group name="some-radios" v-model="composantes.typeActives"
                                                               plain
                                                               :variant="Variant" :aria-describedby="ariaDescribedby">
                                            <b-form-checkbox v-for="(usage, indexU) in composantesBDD.usages"
                                                             @change.passive="modifComposante = true"
                                                             :value="usage.id" :key="indexU">
                                                {{ usage.labelFr }}<sub>abs</sub>
                                            </b-form-checkbox>
                                        </b-form-checkbox-group>
                                    </b-form-group>
                                </b-col>
                                <b-col md="auto">
                                    <b-button v-if="activeValueClimaticZone == true"
                                              :variant="'outline-' + Variant" class="badge"
                                              @click.stop="activeValueClimaticZone = !activeValueClimaticZone">
                                        Cacher tous les tableaux de zones climatiques
                                    </b-button>
                                    <b-button v-else :variant="'outline-' + Variant" class="badge"
                                              @click.stop="activeValueClimaticZone = !activeValueClimaticZone">
                                        Déplier tous les tableaux de zones climatiques
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row v-if="composantes.typeActives.length > 0" class="w-100 m-0"
                                   v-for="(value, index) in composantes?.typeActives"
                                   :key="index">
                                <b-col class="h-100 m-0 p-1 w-100">
                                    <h5 class="pt-2">
                                        {{ composantesBDD.usages.find(a => a.id == value).labelFr }}<sub>abs</sub>
                                    </h5>
                                    <b-input-group>
                                        <template #prepend>
                                            <h6 class="p-1 pr-2">Toutes les altitudes et zones climatiques </h6>
                                        </template>
                                        <b-form-input :id="'inputAll' + value" number no-wheel
                                                      :formatter="numberFormatter" class="mb-2"
                                                      @input.passive="modifComposante = true"
                                                      v-model="composantes.composanteActives[value][0][1].value">
                                        </b-form-input>
                                    </b-input-group>
                                    <b-table-simple hover small caption-top responsive class="text-center w-100">
                                        <b-thead>
                                            <b-tr>
                                                <b-th rowspan="2" size="sm"></b-th>
                                                <b-th :colspan="composantesBDD.climaticAreas.length">
                                                    Zones climatiques
                                                </b-th>
                                            </b-tr>
                                            <b-tr v-if="activeValueClimaticZone == true">
                                                <b-th v-for="(climaticArea, index) in composantesBDD.climaticAreas"
                                                      :key="index">
                                                    {{ climaticArea.labelFr }}
                                                </b-th>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody v-if="activeValueClimaticZone == true">
                                            <b-tr v-for="(altitude, indexA) in composantesBDD.altitudes" :key="indexA">
                                                <b-th>
                                                    <template v-for="(label, indexL) in altitude.labelFr.split('/')">
                                                        {{ label }} <br
                                                        v-if="indexL != altitude.labelFr.split('/').length - 1"/>
                                                    </template>
                                                </b-th>
                                                <b-td v-for="(climaticArea, indexC) in composantesBDD.climaticAreas"
                                                      :key="indexC"
                                                      :class="composantesBDD.impossibleMix.findIndex(a=> a.altitudeId == altitude.id && a.climaticAreaId == climaticArea.id) == -1 ?
                                                            '' : 'bg-gray-light'">
                                                    <b-form-input number no-wheel
                                                                  :formatter="numberFormatter"
                                                                  v-if="composantesBDD.impossibleMix.findIndex(a=> a.altitudeId == altitude.id && a.climaticAreaId == climaticArea.id) == -1"
                                                                  @input.passive="modifComposante = true"
                                                                  v-model="composantes.composanteActives[value][altitude.id][climaticArea.id].value">
                                                    </b-form-input>
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </div>
            </b-col>
        </b-row>
        <!--<b-row class="w-100 h-100 m-0" v-if="activeTab == 2">
            <b-col class="m-0 p-1">
                Importer un décret
            </b-col>
        </b-row>-->

        <b-modal id="modal-modif-activity" title-html="<h5>Ajouter/modifier une activité</h5>"
                 cancel-title="Annuler" ok-title="Valider"
                 :ok-variant="Variant" :cancel-variant="'outline-' + Variant"
                 no-close-on-backdrop no-close-on-esc centered
                 @hidden="resetActivityModal" @ok="handleActivityOk"
                 cancel-:variant="'outline-' + Variant">
            <b-form ref="activityForm">
                <b-form-group label="Code" label-for="code-input" label-cols="2"
                              invalid-feedback="Le code de l'activité est obligatoire."
                              :state="codeActivityState">
                    <b-form-input id="code-input" v-model="modalSelectedActivity.Code" required
                                  :state="codeActivityState"></b-form-input>
                </b-form-group>
                <b-form-group label="Nom" label-for="label-input" label-cols="2"
                              invalid-feedback="Le nom de l'activité est obligatoire."
                              :state="labelActivityState">
                    <b-form-input id="label-input" v-model="modalSelectedActivity.Name" required
                                  :state="labelActivityState"></b-form-input>
                </b-form-group>
            </b-form>
        </b-modal>

        <b-modal id="modal-modif-subactivity" title-html="<h5>Ajouter/modifier une sous-activité</h5>"
                 cancel-title="Annuler" ok-title="Valider"
                 :ok-variant="Variant" :cancel-variant="'outline-' + Variant"
                 no-close-on-backdrop no-close-on-esc centered
                 @hidden="resetSubactivityModal" @ok="handleSubactivityOk"
                 cancel-:variant="'outline-' + Variant">
            <b-form ref="subactivityForm" :style="generateVariantStyle(Variant)">
                <b-form-group label="Code" label-for="code-input" label-cols="2"
                              invalid-feedback="Le code de la sous-activité est obligatoire."
                              :state="codeSubactivityState">
                    <b-form-input id="code-input" v-model="modalSelectedSubactivity.Code" required
                                  :state="codeSubactivityState"></b-form-input>
                </b-form-group>
                <b-form-group label="Nom" label-for="label-input" label-cols="2"
                              invalid-feedback="Le nom de la sous-activité est obligatoire."
                              :state="labelSubactivityState">
                    <b-form-input id="label-input" v-model="modalSelectedSubactivity.Name" required
                                  :state="labelSubactivityState"></b-form-input>
                </b-form-group>
                <b-form-group label="" label-for="energies-input" label-cols="2">
                    <b-form-checkbox-group v-model="modalSelectedSubactivity.EnergyTypes" id="energies-input" stacked
                                           plain>
                        <b-form-checkbox value="Heating">Chauffage</b-form-checkbox>
                        <b-form-checkbox value="Cooling">Refroidissement</b-form-checkbox>
                        <b-form-checkbox value="ColdLogistics">Logistique de froid</b-form-checkbox>
                        <b-form-checkbox value="CommercialRefrigeration">Froid commercial</b-form-checkbox>
                        <b-form-checkbox value="DocumentsPreservation">Conservation de documents ou de collections
                        </b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-form>
        </b-modal>

        <b-modal id="modal-modif-intensity"
                 :title-html="'<h5>Ajouter/modifier un indicateur d’intensité d’usage' +
                            (modalSelectedIntensity?.userModified ? '' : ' étalon') + '</h5>'"
                 cancel-title="Annuler" ok-title="Valider"
                 :ok-variant="Variant" :cancel-variant="'outline-' + Variant"
                 no-close-on-backdrop no-close-on-esc centered
                 @hidden="resetIntensityModal" @ok="handleIntensityOk"
                 cancel-:variant="'outline-' + Variant">
            <b-form ref="intensityForm" @submit.stop.prevent="handleIntensitySubmit"
                    :style="generateVariantStyle(Variant)">
                <b-form-group label="Code" label-for="code-input" label-cols="2"
                              invalid-feedback="Le code de l'intensité d'usage est obligatoire."
                              :state="codeIntensityState">
                    <b-form-input id="code-input" v-model="modalSelectedIntensity.code" required
                                  :state="codeIntensityState"></b-form-input>
                </b-form-group>
                <b-form-group label="Nom" label-for="label-input" label-cols="2"
                              invalid-feedback="Le nom de l'intensité d'usage est obligatoire."
                              :state="labelIntensityState">
                    <b-form-input id="label-input" v-model="modalSelectedIntensity.labelFr" required
                                  :state="labelIntensityState"></b-form-input>
                </b-form-group>
                <b-form-group label="Valeur" label-for="value-input" label-cols="2">
                    <b-form-input id="value-input" v-model="modalSelectedIntensity.value" number no-wheel
                                  :formatter="numberFormatter"/>
                </b-form-group>
                <b-form-group>
                    <b-form-checkbox name="negative-input" v-model="modalSelectedIntensity.allowNegative" plain>
                        Autorise une valeur négative
                    </b-form-checkbox>
                </b-form-group>
            </b-form>
        </b-modal>

        <b-modal id="modal-import-climaticalzone"
                 :title-html="'<h5>Importer des composantes en fonction de la zone climatique</h5>'"
                 cancel-title="Annuler" ok-title="Importer"
                 :ok-variant="Variant" :cancel-variant="'outline-' + Variant"
                 no-close-on-backdrop no-close-on-esc centered size="lg"
                 @hidden="textAreaClimaticalZone = ''" @ok="handleClimaticalZoneOk"
                 cancel-:variant="'outline-' + Variant">
            <b-form ref="climaticalzoneForm" @submit.stop.prevent="handleClimaticalZoneOk">
                <b-form-textarea v-model="textAreaClimaticalZone" class="h-100" rows="9" no-resize
                                 placeholder="Coller le texte contenu présent dans l'arrêté pour cette sous-activité"/>
            </b-form>
        </b-modal>
    </b-container>
</template>
<script lang="ts">
import {Component, InjectReactive, Prop, ProvideReactive, Vue, Watch} from 'vue-property-decorator';
import Dictionary from "@/types/Dictionary";
import axios from "axios";
import {API_URL} from "@/App.settings";
import moment from "moment/moment";
import {mixins} from "vue-class-component";
import {ThemeUtils} from "@/components/commons/Utils";
import GenericTable, {
    HeaderString, HeaderCustom, IHeader, Row, CssClass,
    SelectionTypeEnum
} from "@/components/commons/Generics/GenericTable.vue";
import GenericButton, {ButtonsType, ButtonsAction} from '@/components/commons/Generics/GenericButton.vue';

//#region Class

class ActivityRow extends Row {
    private _code: string;
    private _status: number;
    private _subactivities: SubactivityRow[];

    constructor(id: string, name: string, code: string, status: number, subactivities: SubactivityRow[], data: Partial<ActivityRow>) {
        super(id, name, data);
        this._code = code;
        this._status = status;
        this._subactivities = subactivities
    }

    public get Code(): string {
        return this._code;
    }

    public set Code(value: string) {
        this._code = value;
    }

    public get Status(): number {
        return this._status;
    }

    public set Status(value: number) {
        this._status = value;
    }

    public get Subactivities() {
        return this._subactivities;
    }

    public set Subactivities(value: SubactivityRow[]) {
        this._subactivities = value;
    }
}

class SubactivityRow extends Row {
    private _code: string;
    private _status: number;
    private _energyTypes: string[];

    constructor(id: string, name: string, code: string, status: number, energyTypes: string[], data: Partial<ActivityRow>) {
        super(id, name, data);
        this._code = code;
        this._status = status;
        this._energyTypes = energyTypes;
    }

    public get Code(): string {
        return this._code;
    }

    public set Code(value: string) {
        this._code = value;
    }

    public get Status(): number {
        return this._status;
    }

    public set Status(value: number) {
        this._status = value;
    }

    public get EnergyTypes() {
        return this._energyTypes;
    }

    public set EnergyTypes(value: string[]) {
        this._energyTypes = value;
    }
}

//#endregion Class

@Component({
    components: {
        GenericButton,
        GenericTable
    }
})
export default class TertiaryDecree extends mixins(Vue, ThemeUtils) {
    // Déclaration des Enums Buttons
    public ButtonsType = ButtonsType;
    public ButtonsAction = ButtonsAction;
    // Déclaration des types de tableaux (GenericTable.vue)
    private selectionTypeEnum = SelectionTypeEnum;

    /** Variant du composant */
    @Prop({default: () => 'primary'})
    @ProvideReactive()
    public Variant!: string;

    /** Action du composant */
    @ProvideReactive()
    public Action: string;

    /** Numéro de l'onglet affiché */
    private activeTab: number = 0;

    //#region Partie Activités
    private activityItemPerPage: number = 10;
    private activityCurrentPage: number = 1;
    private loadingActivities: boolean = true;
    private modalSelectedActivity: ActivityRow = new ActivityRow(undefined, undefined, undefined, 0, [], {});
    private labelActivityState: boolean = null;
    private codeActivityState: boolean = null;
    /** Données */
    private activities: ActivityRow[] = [];

    /** Tableau des entêtes du tableau */
    private activityFields: IHeader[] = [];

    private activityHeaderHeight: string = "";

    /** Récupère la liste des activités et sous-activités en lien */
    private loadActivities(activityId: string = undefined) {
        // Écran de chargement
        this.$store.dispatch("ShowLoadingMask", "Chargement en cours");

        this.loadingActivities = true;

        this.activities.splice(0, this.activities.length);

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

        axios.post(API_URL + 'TertiaryDecress/Activities/LoadData', args).then((response) => {
            if (response && response.data) {
                console.debug("TertiaryDecree - loadActivities - axiosResult", response.data);

                this.activities = response.data.Activities.map(a => new ActivityRow(a.id,
                    a.labelFr, a.code, a.status,
                    a.subactivities.map(b => new SubactivityRow(b.id, b.labelFr, b.code, b.status, b.energyTypes, {
                        CssClasses: [new CssClass({
                            CssClass: "text-decoration-line-through",
                            LogicalExpression: "value.Status == 2"
                        })]
                    })),
                    {
                        CssClasses: [new CssClass({
                            CssClass: "text-decoration-line-through",
                            LogicalExpression: "value.Status == 2"
                        })]
                    }));

                this.activityCurrentPage = 1;
                this.subactivities = [];
                this.subactivityCurrentPage = 1;
                Vue.set(this, 'subactivityCurrentPage', 1);

                if (activityId != undefined) {
                    let activityIndex = this.activities.findIndex(a => a.Id == activityId);
                    let activity: ActivityRow = this.activities[activityIndex];
                    activity.Selected = true;

                    // Changement de page pour afficher l'activité.
                    this.activityCurrentPage = Math.trunc((activityIndex / this.activityItemPerPage) + 1);

                    this.loadSubctivities(activity);
                }
            }
            this.$store.dispatch("HideLoadingMask", {})
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                    title: "Erreur",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        }).finally(() => {
            this.$store.dispatch("HideLoadingMask", {});
            this.loadingActivities = false;
        });
    }

    /** Réinitialise l'activité ajoutée ou modifiée */
    protected resetActivityModal() {
        this.modalSelectedActivity = new ActivityRow(undefined, undefined, undefined, 0, [], {});
    }

    /** Enregistre une activité (ajout ou modification) */
    protected handleActivitySubmit(checkValidity: boolean = true) {
        // Exit when the form isn't valid
        if (checkValidity && !this.checkFormValidityActivity()) {
            return;
        }

        // Enregistrement et rechargement de la liste
        this.$store.dispatch("ShowLoadingMask", "Suppression en cours");
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["Activity"] = {
            id: this.modalSelectedActivity.Id,
            code: this.modalSelectedActivity.Code,
            labelFr: this.modalSelectedActivity.Name,
            status: this.modalSelectedActivity.Status,
            subactivities: this.modalSelectedActivity.Subactivities
        };

        axios.post(API_URL + 'TertiaryDecress/Activity/Save', args).then((response) => {
            this.$store.dispatch("HideLoadingMask", {})
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                    title: "Erreur",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        });

        this.loadActivities(this.modalSelectedActivity.Id);

        // Hide the modal manually
        this.$nextTick(() => {
            this.$bvModal.hide('modal-modif-activity');
        })
    }

    protected modifyActivity(activity: ActivityRow) {
        if (activity != undefined)
            this.modalSelectedActivity = new ActivityRow(activity.Id, activity.Name, activity.Code, activity.Status,
                activity.Subactivities, {});
        else
            this.modalSelectedActivity = new ActivityRow(undefined, undefined, undefined, 0, [], {});
        this.$root.$emit('bv::show::modal', 'modal-modif-activity', '#btnShow');
    }

    /** Suppression d'une activité */
    protected removeActivity(activity: ActivityRow, desactived: boolean = false) {
        this.$bvModal.msgBoxConfirm('Confirmez-vous ' + (desactived ? 'l\'archivage' : 'la suppression') + ' de l\'activité "' + activity.Name + '" ?', {
            title: (desactived ? 'Archivage' : 'Suppression') + ' d\'une activité',
            okVariant: 'danger', okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
            cancelTitle: 'Non', hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) {
                this.$store.dispatch("ShowLoadingMask", "Suppression en cours");
                const args: Dictionary<any> = {};
                args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                args["ActivityId"] = activity.Id;

                axios.post(API_URL + 'TertiaryDecress/Activity/Remove', args).then((response) => {
                    this.loadActivities(desactived ? activity?.Id : undefined);

                    this.$store.dispatch("HideLoadingMask", {});
                    this.$bvToast.toast((desactived ? 'Archivage' : 'Suppression') + " de l'activité faite.", {
                        title: (desactived ? 'Archivage' : 'Suppression') + " d'une activité",
                        autoHideDelay: 10000,
                        variant: "info",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                }).catch(err => {
                    console.error(err);
                    this.$store.dispatch("HideLoadingMask", {}).then(() => {
                        this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                            title: "Erreur",
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    });
                });
            }
        });
    }

    /** Validation d'un ajout ou d'une modification d'une activité */
    protected handleActivityOk(event) {
        this.$store.dispatch("ShowLoadingMask", this.$t('Loading'));
        // Prevent modal from closing
        event.preventDefault();
        // Trigger submit handler
        this.handleActivitySubmit();

        //this.activitySearchValue = this.modalSelectedActivity.code;
        //this.changeActivitySearchValue();
        //TODO : voir pour ajouter l'élément à la recherche.

        this.$store.dispatch("HideLoadingMask", {});
    }

    /** Vérification de la validité des champs pour l'ajout ou la modification d'une activité */
    protected checkFormValidityActivity() {
        this.codeActivityState = null;
        this.labelActivityState = null;

        const valid = (this.$refs.activityForm as any).checkValidity();
        if (!valid && (this.modalSelectedActivity.Name == undefined || this.modalSelectedActivity.Name == ""))
            this.labelActivityState = false;
        if (!valid && (this.modalSelectedActivity.Code == undefined || this.modalSelectedActivity.Code == ""))
            this.codeActivityState = false;
        return valid;
    }

    /** Permet la publication de l'activité (données présentes pour els utilisateurs) */
    protected publishActivity(activity: ActivityRow) {
        this.$bvModal.msgBoxConfirm('Désirez-vous publier l\'activité "' + activity.Name + '" avec ses sous-activtés et indicateurs d\'intensité d\'usage ?', {
            title: 'Publication d\'une activité',
            okVariant: this.Variant, okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
            cancelTitle: 'Non', hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) {
                this.modalSelectedActivity = activity;
                this.modalSelectedActivity.Status = 1;
                this.handleActivitySubmit(false);

                let subactivities = activity.Subactivities;
                for (let i = 0; i < subactivities.length; i++) {
                    if (subactivities[i].Status == 0) {
                        subactivities[i].Status = 1;
                        this.modifySubactivity(subactivities[i], false);
                        this.handleSubactivitySubmit(false);
                    }
                }
                this.loadActivities(activity?.Id);
            }
        });
    }

    //#endregion

    //#region Partie sous-activités
    private subactivityCurrentPage: number = 1;
    private subactivityItemPerPage: number = 10;
    private loadingSubactivities: boolean = true;

    /* Sous-activité sélectionnée dans le tableau */
    private modalSelectedSubactivity: SubactivityRow = new SubactivityRow(undefined, undefined, undefined, 0, [], {});
    private labelSubactivityState: boolean = null;
    private codeSubactivityState: boolean = null;

    /** Tableau des résultats */
    private subactivities: SubactivityRow[] = [];

    /** Tableau des entêtes du tableau */
    private subactivityFields: IHeader[] = [];

    /** Execute la recherche et récupère les résultats */
    private loadSubctivities(activity: ActivityRow = undefined) {
        // Écran de chargement
        this.$store.dispatch("ShowLoadingMask", "Chargement en cours");
        this.loadingSubactivities = true;

        this.activities.filter(a => a.Selected).forEach((a) => {
            a.Selected = false;
            return a;
        });
        activity.Selected = true;

        this.subactivityCurrentPage = 1;        // Retour à la première page.
        Vue.set(this, 'subactivityCurrentPage', 1);
        this.subactivities = [...activity?.Subactivities];
        this.loadingSubactivities = false;

        this.$store.dispatch("HideLoadingMask", {});
    }

    private modifySubactivity(subactivity: SubactivityRow, showModal: boolean = true) {
        this.modalSelectedSubactivity = new SubactivityRow(subactivity.Id, subactivity.Name, subactivity.Code,
            subactivity.Status, subactivity.EnergyTypes, {});

        if (showModal)
            this.$root.$emit('bv::show::modal', 'modal-modif-subactivity', '#btnShow')
    }

    /** Réinitialise la sous-activité ajoutée ou modifiée */
    protected resetSubactivityModal() {
        this.modalSelectedSubactivity = new SubactivityRow(undefined, undefined, undefined, 0,
            undefined, {});
    }

    /** Enregistre une sous-activité (ajout ou modification) */
    protected handleSubactivitySubmit(checkValidity: boolean = true) {
        // Exit when the form isn't valid
        if (checkValidity && !this.checkFormValiditySubactivity()) {
            return;
        }

        // Enregistrement et rechargement de la liste
        this.$store.dispatch("ShowLoadingMask", "Ajout/modification en cours");
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["Subactivity"] = {
            id: this.modalSelectedSubactivity.Id,
            code: this.modalSelectedSubactivity.Code,
            labelFr: this.modalSelectedSubactivity.Name,
            status: this.modalSelectedSubactivity.Status,
            activityId: this.activities.find(a => a.Selected == true)?.Id,
            energyTypes: this.modalSelectedSubactivity.EnergyTypes
        };

        axios.post(API_URL + 'TertiaryDecress/Subactivity/Save', args).then((response) => {
            let activity = this.activities.find(a => a.Selected == true);
            this.loadActivities(activity?.Id);
            this.loadSubctivities(activity)
            this.$store.dispatch("HideLoadingMask", {});
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                    title: "Erreur",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        });

        // Hide the modal manually
        this.$nextTick(() => {
            this.$bvModal.hide('modal-modif-subactivity');
        })
    }

    /**
     * Suppression d'une sous-activité
     * @param subactivity
     * @param desactived
     * @protected
     */
    protected removeSubactivity(subactivity: SubactivityRow, desactived: boolean = false) {
        this.$bvModal.msgBoxConfirm('Confirmez-vous ' + (desactived ? 'l\'archivage' : 'la suppression') + ' la sous-activité "' + subactivity.Name + '" ?',
            {
                title: (desactived ? 'Archivage' : 'Suppression') + ' d\'une sous-activité',
                okVariant: 'danger', okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
                cancelTitle: 'Non', hideHeaderClose: false,
                centered: true
            }).then(value => {
            if (value) {
                this.$store.dispatch("ShowLoadingMask", "Suppression en cours");
                const args: Dictionary<any> = {};
                args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                args["SubactivityId"] = subactivity.Id;

                axios.post(API_URL + 'TertiaryDecress/Subactivity/Remove', args).then((response) => {
                    this.loadActivities(this.activities.find(a => a.Selected == true)?.Id);

                    this.$store.dispatch("HideLoadingMask", {});
                    this.$bvToast.toast("Suppression de la sous-activité faite.", {
                        title: "Suppression d'une sous-activité",
                        autoHideDelay: 10000,
                        variant: "success",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                }).catch(err => {
                    console.error(err);
                    this.$store.dispatch("HideLoadingMask", {}).then(() => {
                        this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                            title: "Erreur",
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    });
                });
            }
        });
    }

    /** Validation d'un ajout ou d'une modification d'une sous-activité */
    protected handleSubactivityOk(event) {
        // Prevent modal from closing
        event.preventDefault();
        // Trigger submit handler
        this.handleSubactivitySubmit();
    }

    /** Vérification de la validité des champs pour l'ajout ou la modification d'une sous-activité */
    protected checkFormValiditySubactivity() {
        this.codeSubactivityState = null;
        this.labelSubactivityState = null;

        const valid = (this.$refs.subactivityForm as any).checkValidity();
        if (!valid && (this.modalSelectedSubactivity.Name == undefined || this.modalSelectedSubactivity.Name == ""))
            this.labelSubactivityState = false;
        if (!valid && (this.modalSelectedSubactivity.Code == undefined || this.modalSelectedSubactivity.Code == ""))
            this.codeSubactivityState = false;
        return valid;
    }

    protected publishSubactivity(subactivity: SubactivityRow) {
        this.$bvModal.msgBoxConfirm('Désirez-vous publier la sous-activité "' + subactivity.Name + '" avec ses indicateurs d\'intensité d\'usage ?', {
            title: 'Publication d\'une sous-activité',
            okVariant: this.Variant, okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
            cancelTitle: 'Non', hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) {
                this.modalSelectedSubactivity = subactivity;
                this.modalSelectedSubactivity.Status = 1;
                this.handleSubactivitySubmit(false);
            }
        });
    }

    //#endregion

    //#region Composantes
    private modifComposante: boolean = false;
    private composantes: any = {};

    private activeComposante: boolean = true;
    private activeComposanteUSE: boolean = true;
    private activeComposanteIndicator: boolean = true;
    private activeValueClimaticZone: boolean = true;
    private activeValues: boolean = false;

    private textAreaClimaticalZone: string = '';

    //private valueBDDType: string = 'PROD';

    private composantesBDD: any = {};

    private modalSelectedIntensity: {
        id: number | null | undefined,
        code: string,
        labelFr: string,
        value: number | null | undefined,
        userModified: boolean | null | undefined,
        allowNegative: boolean | null | undefined,
        status: number | null | undefined,
    } = {
        id: undefined,
        code: undefined,
        labelFr: undefined,
        value: undefined,
        userModified: undefined,
        allowNegative: undefined,
        status: 0
    };
    private labelIntensityState: boolean = null;
    private codeIntensityState: boolean = null;

    private onClickDate: moment.Moment = moment();

    /** Chargement des composantes de la sous-activité */
    private loadConstantes(subactivity: SubactivityRow = undefined) {
        console.debug('TertiaryDecree.vue - loadConstantes - diff time between click : %O', moment().diff(this.onClickDate));
        if (moment().diff(this.onClickDate) > 100) {
            this.onClickDate = moment();
            if (this.modifComposante) {
                this.$bvModal.msgBoxConfirm('Des informations sont actuellement en modification. Souhaitez-vous annuler ces modifications ?', {
                    title: 'Informations en modification',
                    okVariant: 'danger', okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
                    cancelTitle: 'Non', hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    if (value) {
                        this.subactivities.filter(a => a.Selected).forEach((a) => {
                            a.Selected = false;
                            return a;
                        });

                        let subactivitiesInit = this.subactivities.find(a => a.Id == subactivity.Id);
                        subactivitiesInit.Selected = true;

                        this.loadConstanteValues(subactivity);
                    }
                });
            } else {
                this.subactivities.filter(a => a.Selected).forEach((a) => {
                    a.Selected = false;
                    return a;
                });

                let subactivitiesInit = this.subactivities.find(a => a.Id == subactivity.Id);
                subactivitiesInit.Selected = true;

                this.loadConstanteValues(subactivity);
            }
        }
    }

    /** Chargement des composantes de la sous-activité */
    private backConstantes() {
        console.debug('TertiaryDecree.vue - loadConstantes - diff time between click : %O', moment().diff(this.onClickDate));
        if (moment().diff(this.onClickDate) > 100) {
            this.onClickDate = moment();
            if (this.modifComposante) {
                this.$bvModal.msgBoxConfirm('Des informations sont actuellement en modification. Souhaitez-vous ENREGISTRER ces modifications ?', {
                    title: 'Informations en modification',
                    okVariant: 'danger', okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
                    cancelTitle: 'Non', hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    if (value) {
                        this.saveComposantes(false);
                    } else {
                        this.modifComposante = false;
                    }
                });
            }
        }
        this.activeTab = 0;
    }

    /** Chargement des composantes de la sous-activité */
    private loadConstanteValues(subactivity: SubactivityRow = undefined, changeTab: boolean = true) {
        // Écran de chargement
        this.$store.dispatch("ShowLoadingMask", "Chargement en cours");
        this.modalSelectedSubactivity = subactivity;

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["SubactivityId"] = this.modalSelectedSubactivity.Id;

        axios.post(API_URL + 'TertiaryDecress/Constantes/LoadData', args).then((response) => {
            if (response && response.data) {
                console.debug("TertiaryDecree - loadConstanteValues - axiosResult", response.data);
                this.composantesBDD = response.data["Composantes"];
                this.modifComposante = false;
                //this.valueBDDType = "PROD";
                this.changeValueBDDType();

                if (changeTab)
                    this.activeTab = 1;
            }
            this.$store.dispatch("HideLoadingMask", {})
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                    title: "Erreur",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        });
    }

    /** Rechargement des valeurs des composantes */
    private reloadComposantes() {
        if (this.modifComposante) {
            this.$bvModal.msgBoxConfirm('Des informations sont actuellement en modification. Souhaitez-vous ENERGISTRER ces modifications ?', {
                title: 'Informations en modification',
                okVariant: 'danger', okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
                cancelTitle: 'Non', hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    this.saveComposantes();
                } else {
                    this.modifComposante = false;
                    this.changeValueBDDType();
                }
            });
        } else {
            this.changeValueBDDType();
        }
    }

    /** Au changement des données initiales */
    protected changeValueBDDType() {
        this.composantes = JSON.parse(JSON.stringify(this.composantesBDD.composantes['PROD']));

        let composanteValues: any[][] = new Array((this.composantesBDD?.altitudes?.length ?? 0) + 1)
            .fill(false).map(() => new Array((this.composantesBDD?.climaticAreas?.length ?? 0) + 1).fill(false))
            .map((a, i) => a.map((b, j) => ({
                altitudeId: i,
                climaticAreaId: j,
                id: undefined,
                value: undefined
            })));
        for (let i = 0; i < this.composantes.composanteValues.length; i++) {
            let composante = this.composantes.composanteValues[i];
            if (composante != undefined)
                composanteValues[composante.altitudeId][composante.climaticAreaId] = JSON.parse(JSON.stringify(composante));
        }
        this.composantes.composanteValues = JSON.parse(JSON.stringify(composanteValues));

        for (let i = 0; i < this.composantesBDD.usages.length; i++) {
            let typeActive = this.composantesBDD.usages[i].id;
            let composanteActives: any[][] = new Array((this.composantesBDD?.altitudes?.length ?? 0) + 1)
                .fill(false).map((a, i) => new Array((this.composantesBDD?.climaticAreas?.length ?? 0) + 1)
                    .fill(false).map((a, j) =>
                        ({
                            altitudeId: i,
                            climaticAreaId: j,
                            utility: typeActive,
                            id: undefined,
                            value: undefined
                        })));
            if (this.composantes.composanteActives[typeActive] != undefined) {
                for (let i = 0; i < this.composantes.composanteActives[typeActive].length; i++) {
                    let composante = this.composantes.composanteActives[typeActive][i];
                    if (composante != undefined && composante.altitudeId != undefined && composante.climaticAreaId != undefined)
                        composanteActives[composante.altitudeId][composante.climaticAreaId] = JSON.parse(JSON.stringify(composante));
                }
            }
            this.composantes.composanteActives[typeActive] = composanteActives;
        }
        this.activeValues = this.composantes?.typeActives.length;

        this.activeValueClimaticZone = false;
        for (let i = 0; i < this.composantes?.typeActives.length; i++) {
            this.activeValueClimaticZone ||= this.composantes?.typeActives[i].length > 1;
        }
    }

    /** Réinitialise l'intensité d'usage ajoutée ou modifiée */
    protected resetIntensityModal() {
        this.modalSelectedIntensity = {
            id: undefined,
            code: undefined,
            labelFr: undefined,
            value: undefined,
            userModified: undefined,
            allowNegative: undefined,
            status: 0
        };
    }

    /** Enregistre une intensité d'usage (ajout ou modification) */
    protected handleIntensitySubmit(checkValidity: boolean = true) {
        // Exit when the form isn't valid
        if (checkValidity && !this.checkFormValidityIntensity()) {
            return;
        }

        this.$store.dispatch("ShowLoadingMask", "Ajout/modification en cours");
        if (this.modalSelectedIntensity.id == undefined) {
            // Ajout d'un nouvel indicateur d'intensité d'usage
            if (!('indicators' in this.composantes)) {
                this.composantes = {};
            }
            if (this.composantes.indicators == undefined) {
                this.composantes.indicators = [];
            }
            this.composantes.indicators.push({
                id: this.composantes.indicators.length * (-1),
                code: this.modalSelectedIntensity.code,
                labelFr: this.modalSelectedIntensity.labelFr,
                value: this.modalSelectedIntensity.value != undefined ? parseFloat(this.modalSelectedIntensity.value.toString()) : undefined,
                allowNegative: this.modalSelectedIntensity.allowNegative,
                userModified: this.modalSelectedIntensity.userModified,
                status: this.modalSelectedIntensity.status,
            });
        } else {
            // Modification d'un indicateur d'intensité d'usage
            let indicator = this.composantes.indicators.find(a => a.id == this.modalSelectedIntensity.id);
            if (indicator != undefined) {
                indicator.code = this.modalSelectedIntensity.code;
                indicator.labelFr = this.modalSelectedIntensity.labelFr;
                indicator.value = this.modalSelectedIntensity.value != undefined && this.modalSelectedIntensity.value.toString() != "" ?
                    parseFloat(this.modalSelectedIntensity.value.toString()) : undefined;
                indicator.allowNegative = this.modalSelectedIntensity.allowNegative;
                indicator.userModified = this.modalSelectedIntensity.userModified;
                indicator.status = this.modalSelectedIntensity.status;
            }
        }
        this.$store.dispatch("HideLoadingMask", {});

        this.modifComposante = true;

        // Hide the modal manually
        this.$nextTick(() => {
            this.$bvModal.hide('modal-modif-intensity');
        })
    }

    /** Suppression d'une intensité d'usage */
    protected removeIntensity(intensity: any, desactived: boolean = false) {
        this.$bvModal.msgBoxConfirm('Confirmez-vous la ' + (desactived ? "désactivation" : "suppression") + ' de l\'un indicateur d\'intensité d\'usage "' + intensity.labelFr + '" ?', {
            title: (desactived ? "Désactivation" : "Suppression") + ' d\'indicateur d\'intensité d\'usage',
            okVariant: 'danger', okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
            cancelTitle: 'Non', hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) {
                this.$store.dispatch("ShowLoadingMask", (desactived ? "Désactivation" : "Suppression") + " en cours");
                let indicatorIndex = this.composantes.indicators.findIndex(a => a.id == intensity.id);
                if (desactived) {
                    this.composantes.indicators[indicatorIndex].status = 2; /* Désactivé */
                } else {
                    if (indicatorIndex >= 0)
                        this.composantes.indicators.splice(indicatorIndex, 1);
                    this.$store.dispatch("HideLoadingMask", {});
                }
                this.$store.dispatch("HideLoadingMask", {});

                this.modifComposante = true;
            }
        });
    }

    /** Validation d'un ajout ou d'une modification d'une intensité d'usage  */
    protected handleIntensityOk(event) {
        // Prevent modal from closing
        event.preventDefault();
        // Trigger submit handler
        this.handleIntensitySubmit();
    }

    /** Vérification de la validité des champs pour l'ajout ou la modification d'une intensité d'usage  */
    protected checkFormValidityIntensity() {
        this.codeIntensityState = null;
        this.labelIntensityState = null;

        const valid = (this.$refs.intensityForm as any).checkValidity();
        if (!valid && (this.modalSelectedIntensity.labelFr == undefined || this.modalSelectedIntensity.labelFr == ""))
            this.labelIntensityState = false;
        if (!valid && (this.modalSelectedIntensity.code == undefined || this.modalSelectedIntensity.code == ""))
            this.codeIntensityState = false;
        return valid;
    }

    /**
     * À partir des données du décret permet le remplissage du tableau dans la modal de remplissage
     * @private
     */
    private handleClimaticalZoneOk() {
        let values = this.textAreaClimaticalZone.replaceAll('Définie', '')
            .replaceAll('par', '').replaceAll('arrêté', '').split('\n');
        let altitude = 0;
        for (let i = 0; i < values.length; i++) {
            if (values[i].trim().charAt(values[i].trim().length - 1) != 'm' && values[i].trim().lastIndexOf("m ") > 0) {
                let value = values[i].substring(values[i].lastIndexOf("m ") + 1).trim().split(' ');
                let j = 0;
                for (let climaticArea = 0; climaticArea < this.composantesBDD.climaticAreas.length; climaticArea++) {
                    if (this.composantesBDD.impossibleMix.findIndex(a => a.altitudeId == this.composantesBDD.altitudes[altitude].id
                        && a.climaticAreaId == this.composantesBDD.climaticAreas[climaticArea].id) == -1) {
                        this.composantes.composanteValues[this.composantesBDD.altitudes[altitude].id][this.composantesBDD.climaticAreas[climaticArea].id].value = value[j];
                        this.modifComposante = true;
                        j += 1;
                    }
                }
                altitude += 1;
            }
        }
    }

    /**
     * Enregistre les composantes de la sous-activité
     * @protected
     */
    protected saveComposantes(reload: boolean = true) {
        this.$store.dispatch("ShowLoadingMask", "Ajout/modification/Suppression en cours");

        /** Sauvegarde des modifications des indicateurs */
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["SubactivityId"] = this.modalSelectedSubactivity.Id;
        args["Indicators"] = this.composantes.indicators;

        axios.post(API_URL + 'TertiaryDecress/Indicators/Save', args).then((response) => {
            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["SubactivityId"] = this.modalSelectedSubactivity.Id;
            args["USEValue"] = this.composantes.useValue;
            let formula = this.composantes.formula;
            formula = formula?.replaceAll('[Part_USE_variable]', this.composantes.useVariable?.toString());
            args["Formula"] = formula;

            axios.post(API_URL + 'TertiaryDecress/Subactivity/SaveComposante', args).then((response) => {
                const args: Dictionary<any> = {};
                args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                args["SubactivityId"] = this.modalSelectedSubactivity.Id;
                args["ComposanteType"] = this.composantes.type;
                let composanteValues = [];
                if (this.composantes.type != 'None')
                    composanteValues = this.composantes.composanteValues.flat(Infinity);
                for (let i = 0; i < this.composantes.typeActives.length; i++) {
                    composanteValues = [...new Set([...composanteValues, ...this.composantes.composanteActives[this.composantes.typeActives[i]].flat(Infinity)])];
                }
                args["ComposanteValues"] = composanteValues.filter(a => !(a.value == undefined && a.id == undefined));

                axios.post(API_URL + 'TertiaryDecress/Subactivity2Altitude2ClimaticArea/Save', args).then((response) => {
                    this.modifComposante = false;
                    if (reload)
                        this.loadConstantes(this.modalSelectedSubactivity);
                }).catch(err => {
                    console.error(err);
                    this.$store.dispatch("HideLoadingMask", {}).then(() => {
                        this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                            title: "Erreur",
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    });
                });
            }).catch(err => {
                console.error(err);
                this.$store.dispatch("HideLoadingMask", {}).then(() => {
                    this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                        title: "Erreur",
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                });
            });
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast("Une erreur est survenue. Veuillez contacter votre administrateur.", {
                    title: "Erreur",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        });
        this.$store.dispatch("HideLoadingMask", {});
    }

    /**
     * Permet de vérifier la formule en remplaçant les valeurs indiquées entre [].
     * @protected
     */
    protected checkComposantesFormula() {
        let formula = this.composantes.formula;
        formula = formula?.replaceAll('[Part_USE_variable]', this.composantes.useVariable?.toString());
        formula = formula?.replaceAll('[USEEtalon]', this.composantes.useValue?.toString());
        formula = formula?.replaceAll('[Surface]', "1");
        formula = formula?.replaceAll('[Hauteur]', "1");
        formula = formula?.replaceAll('=', "==");       // En SQL, la comparaison est '='. En Js, la comparaison est '=='.
        if (this.composantes.length > 0 && this.composantes[1].length > 0)
            formula = formula?.replaceAll('[CVC]', this.composantes[1][1].value);
        else
            formula = formula?.replaceAll('[CVC]', "1");

        for (let i = 0; i < this.composantes.indicators.length; i++) {
            let indicator = this.composantes.indicators[i];
            if (indicator.code != undefined && indicator.value != undefined)
                formula = formula?.replaceAll('[' + indicator.code + ']', indicator.value?.toString());
            else
                formula = formula?.replaceAll('[' + indicator.code + ']', "1");
        }

        try {
            if (formula.match(/CASE WHEN.+THEN.+ELSE.+END/) != null) {
                let formulaVal = [];
                let regex = /THEN|ELSE/g
                let index = 0;
                while (regex.exec(formula) !== null) {
                    formulaVal.push(formula.substring(index, regex.lastIndex)
                        .replaceAll('CASE WHEN', "")
                        .replaceAll('THEN', "")
                        .replaceAll('ELSE', "")
                        .replaceAll('END', "")
                        .trim());
                    index = regex.lastIndex;
                }
                formulaVal.push(formula.substring(index, formula.length)
                    .replaceAll('CASE WHEN', "")
                    .replaceAll('THEN', "")
                    .replaceAll('ELSE', "")
                    .replaceAll('END', "")
                    .trim());

                for (let i = 0; i < formulaVal.length; i++) {
                    eval(formulaVal[i]);
                }
                this.$bvToast.toast("La formule est valide.", {
                    title: "Vérification de la formule",
                    autoHideDelay: 10000,
                    variant: "success",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            } else {
                eval(formula);
                this.$bvToast.toast("La formule est valide.", {
                    title: "Vérification de la formule",
                    autoHideDelay: 10000,
                    variant: "success",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
        } catch {
            this.$bvToast.toast("La formule est incorrecte. " + formula, {
                title: "Vérification de la formule",
                autoHideDelay: 10000,
                variant: 'danger',
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }
    }

    protected modifyIntensity(intensity) {
        this.modalSelectedIntensity = {
            id: intensity.id,
            code: intensity.code, labelFr: intensity.labelFr,
            value: intensity.value,
            userModified: intensity.userModified,
            allowNegative: intensity.allowNegative,
            status: intensity.status
        };
        this.$root.$emit('bv::show::modal', 'modal-modif-intensity', '#btnShow');
    }

    protected publishIntensity(intensity) {
        this.$bvModal.msgBoxConfirm('Désirez-vous publier l\'indicateur d\'intensité d\'usage "' + intensity.labelFr + '" ?', {
            title: 'Publication d\'un indicateur d\'intensité d\'usage',
            okVariant: this.Variant, okTitle: 'Oui', cancelVariant: 'outline-' + this.Variant,
            cancelTitle: 'Non', hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) {
                this.$store.dispatch("ShowLoadingMask", "Publication en cours");
                let indicatorIndex = this.composantes.indicators.findIndex(a => a.id == intensity.id);
                this.composantes.indicators[indicatorIndex].status = 1; /* Publish */
                this.$store.dispatch("HideLoadingMask", {});

                this.modifComposante = true;
            }
        });
    }

    //#endregion

    protected numberFormatter(value) {
        return value.replace(',', '.');
    }

    public created() {
        this.activityFields = [
            new HeaderString("Code", "Code", {Sort: true,}),
            new HeaderString("Name", "Libelle", {Sort: true,}),
            new HeaderCustom("Status", "Statut", {Sort: true,}),
        ];

        this.subactivityFields = [
            new HeaderString("Code", "Code", {Sort: true,}),
            new HeaderString("Name", "Libelle", {Sort: true,}),
            new HeaderCustom("Status", "Statut", {Sort: true,}),
        ];
    }

    public mounted() {
        this.$store.dispatch("ShowLoadingMask", this.$t('Loading'));
        this.loadActivities();
        this.$store.dispatch("HideLoadingMask", {});
    }

    public updated() {
        // Mise au même niveau des deux tableaux (Activité et Sous-activité).
        if (this.activities.find(a => a.Selected)
            && document.getElementsByClassName('headerHeight')[1] != undefined
            && document.getElementsByClassName('headerHeight')[1].clientHeight != undefined)
            this.activityHeaderHeight =
                document.getElementsByClassName('headerHeight')[1].clientHeight.toString() + "px";
        else
            this.activityHeaderHeight = "";
    }
}
</script>

<style scoped>

/** Pour que la page active prenne en compte la couleur de Variant */
:deep(.page-item.active .page-link) {
    background-color: var(--Variant) !important;
}

:deep(.page-link:hover) {
    background-color: var(--VariantLight) !important;
}

:deep(.text-decoration-line-through) {
    text-decoration: line-through;
}

/** Variable --Variant injectée via generateVariantStyle(Variant) dans ObjectDisplaying (composant commun à toute la fiche objet) */
:deep(input[type=checkbox]:checked) {
    /** Change la couleur de la checkbox */
    accent-color: var(--Variant) !important;
}

:deep(input[type=radio]:checked) {
    /** Change la couleur du bouton radio */
    accent-color: var(--Variant) !important;
}

</style>